import HistoryDataMsg, { HistoryDataMsgProps } from './history-data-msg';

type HistoryDataErrProps = Pick<HistoryDataMsgProps, 'size'>;

const HistoryDataErr = ({ size }: HistoryDataErrProps) => {
  return <HistoryDataMsg size={size}>Can&apos;t Load.</HistoryDataMsg>;
};

export default HistoryDataErr;
